import { observable } from 'mobx'

import Store from '../shared/store'
import { apiStore } from '../shared/api'
import { apiClient } from '../shared/api-impl'

import { user as config } from '../config'

import User from './model'

@apiStore(apiClient)
class UserStore extends Store {

  @observable loading = false

  @observable collection = []

  @observable current = null

  constructor(opts = {}) {

    super(opts)

    this.Model = User

    this.initAPIStore({
      ...opts,
      api: config.api,
    })

  }

  load(...args) {
    return this.api.load(...args)
  }

  save(...args) {
    return this.api.save(...args)
  }

  destroy(...args) {
    return this.api.destroy(...args)
  }

}

export const userStore = new UserStore()



// WEBPACK FOOTER //
// ./src/user/store.js